import "../Styles/Activity.css";

export const Activity = () => {
  return (
    <div>
      <div className="bigbox">
        <h1>Activity</h1>
        <img
          className="imgbox"
          src="https://image01.realme.net/general/20220203/1643859952761.jpg"
          alt=""
        />
        <img
          className="imgbox2"
          src="https://image01.realme.net/general/20220207/1644217462783.jpg"
          alt=""
        />
        <img
          className="imgbox"
          src="https://image01.realme.net/general/20220202/1643815287000.jpg"
          alt=""
        />
        <img
          className="imgbox2"
          src="https://image01.realme.net/general/20211231/1640957957650.jpg"
          alt=""
        />
      </div>
      <div className="longimg">
        <div className="centered">Dare to Leap </div>
        <button className="centeredd">Learn more</button>
      </div>
    </div>
  );
};

export default Activity;
